import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {ActivityPage, activityApi} from '../../services/education/activity.service'
import {UiIcon} from '../../components/UiIcon'
import './Activity.scss'

export function StoryActivities({storyId, onOpen}: {storyId: string | number; onOpen: () => void}) {
  const [data, setData] = useState<ActivityPage>()
  const [error, setError] = useState(false)
  const [retry, setRetry] = useState(0)
  useEffect(() => {
    let active = true
    setData(undefined); setError(false)
    activityApi.list({storyId: String(storyId), page: 1, pageSize: 3}).then(value => {if (active) setData(value)}).catch(() => {if (active) setError(true)})
    return () => {active = false}
  }, [storyId, retry])
  if (data?.total === 0) return null
  return <section className='story-activities' aria-labelledby='story-activities-title'>
    <div className='story-activities-heading'><div><h3 id='story-activities-title'>Hikâyeyle birlikte keşfedin</h3><p>Okumayı etkinliklerle destekleyin.</p></div><span className='activity-symbol'><UiIcon name='activity' size={22}/></span></div>
    {error ? <p role='alert'>İlişkili etkinlikler yüklenemedi. <button className='activity-text-button' onClick={() => setRetry(value => value + 1)}>Tekrar dene</button></p> : !data ? <p role='status'>Etkinlikler yükleniyor…</p> : <>
      <div className='story-activity-list'>{data.items.map(item => <Link key={item.id} to={`/activities/${item.id}`} onClick={onOpen}><UiIcon name='file' size={22}/><div><strong>{item.name}</strong><span>{[item.gradeLevel?.title, item.category?.name, `${item.files.length} dosya`].filter(Boolean).join(' · ')}</span></div><UiIcon name='arrow' size={18}/></Link>)}</div>
      {data.total > data.items.length && <Link className='activity-text-button' to={`/activities?storyId=${storyId}`} onClick={onOpen}>Tüm etkinlikleri gör ({data.total}) <UiIcon name='arrow' size={15}/></Link>}
    </>}
  </section>
}
